module.exports = __webpack_public_path__ + "img/d_03.57e39eec.png";